import styled from 'styled-components';
import { VIOLET_600 } from '@styles/colors';
import { GIVONIC, INTER } from '@styles/fonts';

// Import background images
import CompletedProcessBG from '@assets/images/CompletedProcessBackground.png';

// Export types for TypeScript
export interface CompletedProcessStylesProps { }

export interface ButtonContainerProps {
  $bottomInset: number;
}

export const Container = styled.div<CompletedProcessStylesProps>`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-image: url(${CompletedProcessBG});
  background-size: cover;
  background-position: center;
  padding: 0 12px;
  justify-content: space-between;
`;

export const Icon = styled.img`
  width: 50vw;
  height: 50vw;
  object-fit: contain;
  margin: 0 0 -5vh 0;
`;

export const Title = styled.h1`
  font-family: ${GIVONIC.black};
  font-size: 16px;
  color: ${VIOLET_600};
  margin: 1vh 0;
  text-align: center;
`;

export const Description = styled.p`
  font-family: ${INTER.regular};
  font-size: 14px;
  color: #333;
  text-align: center;
  max-width: 80%;
  margin: 0 0;
`;

export const ButtonContainer = styled.div<ButtonContainerProps>`
  margin-bottom: ${props => props.$bottomInset}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2vh;
`;

export const CenteredContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;
`;
